/**
 * Canonical Cyberweb OPERA OS brand assets.
 * Source of truth: opera-os-logo-master.png (complete artwork — NEVER crop).
 */
import logoMaster from "./opera-os-logo-master.png";
import logoFull from "./opera-os-logo-full.png";
import logoSquare from "./opera-os-logo-square.png";
import logoSquare512 from "./opera-os-logo-square-512.png";
import logoSquare192 from "./opera-os-logo-square-192.png";
import faviconPng from "./opera-os-favicon.png";

export const OPERA_BRAND = {
  name: "Cyberweb OPERA OS",
  shortName: "OPERA OS",
  tagline: "OPERATE · GROW · SUCCEED",
  /** Complete original artwork */
  master: logoMaster,
  /** Complete logo (optimized) */
  full: logoFull,
  /** Complete logo centered in square canvas (contain, padded) */
  square: logoSquare,
  square512: logoSquare512,
  square192: logoSquare192,
  favicon: faviconPng,
} as const;
